<template>
  <div class="login">
    <div class="main">
      <img :src="bk" class="bk-img">
      <div class="centent">
        <div class="title">
          <span style="color: #4B81F7;">欢迎<span style="color: #394868;">登录</span></span>

        </div>
        <div class="from">
          <img :src="fromimg" class="from-img">
          <div class="top">
            <div class="top-yuan"></div>
            <div class="top-span">账户登录</div>
            <div class="top-yuan"></div>
          </div>

          <div class="checkbox">
            <el-checkbox  class="remember" v-model="remember" @change="handleRememberChange">记住密码</el-checkbox>
          </div>
          <div class="Submit">
            <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="" class="demo-ruleForm">
              <el-form-item
                label=""
                prop="username"
                :rules="[
                  { required: true, message: '请输入用户名/手机号'},
                ]"
              >

                <img :src="usernameimg" class="usernameimg">
                <el-input v-model="numberValidateForm.username" autocomplete="off" placeholder="请输入用户名/手机号">

                </el-input>
              </el-form-item>
              <el-form-item
                label=""
                prop="password"
                :rules="[
                  { required: true, message: '请输入密码'},
                ]"
              >
                <img :src="passwordimg" class="usernameimgto">
                <el-input v-model="numberValidateForm.password" autocomplete="off" type="password" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item
                label=""
                prop="rememberMe"
                :rules="[
                  { required: true, message: '请输入验证码'},
                ]"
              >
                <img :src="code" class="usernameimgto">
                <el-input v-model="numberValidateForm.rememberMe" autocomplete="off" type="number" placeholder="请输入验证码"></el-input>
                <img :src="codeUrl" class="codeUrl" @click.stop="getCode">
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('numberValidateForm')" class="botton">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import left from '../assets/left.png'
import bk from '../assets/bk.png'
import fromimg from '../assets/fromimg.png'
import usernameimg from '../assets/username.png'
import passwordimg from '../assets/password.png'
import code from '../assets/code.png'
import {getVerCode,login} from "../utils/login"
export default {
  name: "login",
  data(){
    return{
      left,
      bk,
      fromimg,
      usernameimg,
      passwordimg,
      code,
      numberValidateForm: {
        username: '',
        password:'',
        rememberMe:''
      },
      codeUrl:'',
      sessionid:null,
      remember:true,//是否记住密码
    }
  },
  created() {
    this.$nextTick(() => {
      this.getCode()
    })
  },

  mounted() {
    window.addEventListener('keyup' ,this.onSubmit,false)
    if (window.localStorage.getItem("wo_username")){
      this.numberValidateForm.username=window.localStorage.getItem("wo_username")
      this.numberValidateForm.password=window.localStorage.getItem("wo_password")
      this.remember = true
    }else{
      this.remember = false
    }
  },
  destroyed(){
    window.removeEventListener('keyup',this.onSubmit,false)
  },
  methods:{
    // 获取验证码
    getCode() {
      getVerCode().then((obj) => {
        console.log(obj)
        this.codeUrl = obj[0]
        this.sessionid = obj[1]
      }).catch(err => {
        this.$message.error(err)
      })
    },
    onSubmit(e){
      if (e.keyCode == 13) {
        //回车
        this.submitForm('numberValidateForm')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const metadata = {}
          metadata.session = this.sessionid
          metadata.token = sessionStorage.getItem('token')
          login(this.numberValidateForm.username,this.numberValidateForm.password,this.numberValidateForm.rememberMe,metadata).then(res=>{
            //记住密码
            if (this.remember){
              window.localStorage.setItem("wo_username",this.numberValidateForm.username)
              window.localStorage.setItem("wo_password",this.numberValidateForm.password)
            }else{
              window.localStorage.removeItem("wo_username")
              window.localStorage.removeItem("wo_password")
            }
            sessionStorage.setItem('token',res.token)
            sessionStorage.setItem('userType',res.userType)
            this.$router.replace('/home')
          }).catch(err=>{
            this.$message.error(err.message)
            this.getCode()
          })

        } else {
          return false;
        }
      });
    },
    //是否记住密码
    handleRememberChange(e){
      console.log(e)
      this.remember=e
    },
  }
}
</script>

<style scoped>
.login .el-form .el-input {
  width: 480px !important;
}
.login .el-form /deep/ .el-input__inner{
  height: 74px;
  font-size: 18px;
  padding: 0 50px;
}

</style>
<style lang='scss' scoped>
  .login{
    width: 100%;
    height: 100%;
    .main{
      min-width: 1620px;
      height: 100vh;
      display: flex;
      position: relative;
      overflow-y: hidden;
      overflow-x: hidden;
      .bk-img{
        width: 100%;
        //width: 100%;
        height: 100%;
        animation-name: bg-test1;
        animation-duration: 10000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        z-index: -1;
      }
      .centent{
        position: absolute;
        right: 0;
        top: 0;
        //display: flex;
        //justify-content: center;
        //align-items: center;
        //flex-direction: column;
        text-align: center;
        .title{
          width: 160px;
          //height: 50px;
          font-size: 28px;
          font-weight: 500;
          color: #394868;
          z-index: 2;
          margin-top: 100px;
          margin-right: 230px;
          margin-left: -6px;
        }
        .from{
          z-index: 2;
          min-width: 597px;
          min-height: 683px;
          margin-right: 241px;
          position: relative;
          .from-img{
            width: 100%;
            height: 100%;
          }
          .top{
            position: absolute;
            top: 63px;
            left: 50%;
            transform: translate(-50%);
            display: flex;
            align-items: center;
            .top-span{
              font-size: 28px;
              font-weight: 500;
              color: #000000;
              padding: 0 8px;
            }
            .top-yuan{
              width: 6px;
              height: 6px;
              background: linear-gradient(180deg, #B0D0FA 0%, #8A60FE 100%);
              opacity: 1;
              border-radius: 50%;
            }
          }
          .Submit{
            position: absolute;
            top:153px;
            left: 50%;
            transform: translate(-50%);
            display: flex;
            align-items: center;
            width: 480px;
            .usernameimg{
              width: 28px;
              height: 28px;
              display: flex;
              position: absolute;
              top: 23px;
              left: 13px;
              z-index: 999;
            }
            .usernameimgto{
              width: 20px;
              height: 24px;
              display: flex;
              position: absolute;
              top: 23px;
              left: 17px;
              z-index: 999;
            }
            .codeUrl{
              width:140px;
              height: 60px;
              display: flex;
              position: absolute;
              top: 7px;
              right: 7px;
              z-index: 999;
              border-radius: 2px;
              cursor: pointer;
            }
            .botton{
              width: 480px;
              height: 75px;
              background: #4B81F7;
              border-radius: 38px 38px 38px 38px;
              opacity: 1;
              margin-top: 80px;
            }
          }
          .checkbox{
            position: absolute;
            top:440px;
            left: 74px;
            //transform: translate(-50%);
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue